import { BooleanInput, coerceBooleanProperty, coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'tt-divider-pane',
    templateUrl: './divider-pane.component.html',
    styleUrls: ['./divider-pane.component.css'],
})
export class DividerPaneComponent implements OnChanges {
    @Input()
    public ttId?: string;

    @Input()
    public set ttSize(value: NumberInput) {
        this._size = coerceNumberProperty(value);
    }
    public get ttSize(): number {
        return this._size;
    }
    private _size: number = 0;

    @Input()
    public set ttExpanded(value: BooleanInput) {
        this._expanded = coerceBooleanProperty(value);
    }
    public get ttExpanded(): boolean {
        return this._expanded;
    }
    private _expanded: boolean = true;

    // /**
    //  * When expanded has changed,
    //  */
    @Output()
    public onChange = new EventEmitter<void>();

    constructor(public elementRef: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttSize']) {
            this.ttSize = changes['ttSize'].currentValue;
        }

        if (changes['ttExpanded']) {
            this.ttExpanded = changes['ttExpanded'].currentValue;
        }

        this.onChange.emit();
    }
}
